import modal from "./modal";
import "./index.less";

export class Controller {
	constructor($uibModal) {
		this._uibModal = $uibModal;
	}

	activateModal() {
		this._uibModal
			.open({
				component: "advancedSearchModal",
				size: "lg",
				resolve: {
					lookup: () => this.lookup
				}
			})
			.result.then(selection => {
				this.lookup.selection = selection;
				this.onSelect({
					lookup: this.lookup
				});
			});
	}
}

const deps = [modal];

export default angular
	.module("vesl.components.field-helpers.advanced-search", deps)
	.component("advancedSearch", {
		template: `
    <button type="button"
      class="btn btn-default"
      uib-tooltip="Advanced Search"
      ng-disabled="$ctrl.lookup.disabled"
      ng-click="$ctrl.activateModal()">
        <i class="zmdi zmdi-search"></i>
    </button>
  `,
		controller: Controller,
		bindings: {
			lookup: "<",
			onSelect: "&"
		}
	}).name;
